/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_IdInputs */



/**
* | output |
* | --- |
* | "Job ID" |
*
* @param {Job_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const job_id = /** @type {((inputs?: Job_IdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_IdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ID de tâche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Job-ID")
	if (locale === "it") return /** @type {LocalizedString} */ ("ID lavoro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Идентификатор вакансии")
	if (locale === "es") return /** @type {LocalizedString} */ ("Identificación del trabajo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("职位编号")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ジョブID")
	if (locale === "hi") return /** @type {LocalizedString} */ ("जॉब आईडी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("ID da vaga")
	return /** @type {LocalizedString} */ ("Job ID")
});